import { render, staticRenderFns } from "./talk_tz.vue?vue&type=template&id=75fbf93e&scoped=true&"
import script from "./talk_tz.vue?vue&type=script&lang=js&"
export * from "./talk_tz.vue?vue&type=script&lang=js&"
import style0 from "./talk_tz.vue?vue&type=style&index=0&id=75fbf93e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fbf93e",
  null
  
)

export default component.exports